import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess, 
	AppTabs,
	Show,
	Edit,
	Create,
	Crud,
	trans
} from '@/router/index'

import Container from '@/components/modules/agribios/Container'
import ContainerTabs from '@/components/modules/agribios/ContainerTabs'
import ContainerMaps from '@/components/modules/agribios/ContainerMaps'
import AgribiosSettings from '@/components/modules/agribios/settings/AgribiosSettings.vue'

export const agribios = [
	{
		path: '/containers', 
		beforeEnter: ifAuthenticated,
		component: AppTabs, 
		props: {
			tabs: [
				{
					to: '/containers/',
					text: 'Cassoni',
				},
				{
					to: '/containers/containermovements',
					text: 'Movimentazioni',
				},
				{
					to: '/containers/containermaps',
					text: 'Mappa',
				},
			],
		},
		children: [
			{
				path: '/containers/',
				name: 'containers-index',
				meta: {
					title: 'Cassoni'
				},				
				beforeEnter: (to, from, next) => canAccess('permission', 'container', next),
				component: Crud,
				props: {
					modelDef: 'containers',
					actionIcon: 'mdi-train-car-container',
					title: 'Cassoni',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/containers/containermovements',
				name: 'containermovements-index',
				meta: {
					title: trans('containermovements')
				},				
				beforeEnter: (to, from, next) => canAccess('permission', 'container', next),
				component: Crud,
				props: {
					modelDef: 'containermovements',
					actionIcon: 'mdi-train-car-container',
					title: 'Movimentazioni',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/containers/containermaps',
				meta: {
					title: 'Mappa'
				},				
				beforeEnter: (to, from, next) => canAccess('permission', 'container', next),
				component: ContainerMaps,
			},
		],
	},
	{
		path: '/containers/create',
		name: 'containers-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'containers',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/containers/:id/edit',
		name: 'containers-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'containers',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/containers/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: ContainerTabs,
		props: (route) => ({
			id:  parseInt(route.params.id),
		}),
		children: [
			{
				path: '',
				name: 'containers-show', 
				component: Container,
				meta: {
					title: 'Cassone'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
				}), 
			},
			{
				path: '/containers/:id/containermovements',
				component: Crud,
				meta: {
					title: 'Movimentazioni'
				},				
				props: (route) => ({
					modelDef: 'containermovements',
					actionIcon: 'mdi-train-car-container',
					title: 'Movimentazioni Cassone',
					styleClass: 'mb-offset',
					subFilters: {containers: parseInt(route.params.id)},
					defaultInput: {container_id: parseInt(route.params.id)},					
				}),
			},
		]
	},

	{
		path: '/containermovements/create',
		name: 'containermovements-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'containermovements',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/containermovements/:id/edit',
		name: 'containermovements-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'containermovements',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/containermovements/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/containermovements/' + parseInt(route.params.id) + '/',
					text: 'Movimentazione',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'containermovements-show', 
				component: Show,
				meta: {
					title: 'Movimentazione'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'containermovements',
					modelClass: 'containermovement',
					activities: true,					
				}), 
			},
		]
	},


	{
		path: '/settingscontainers/',
		name: 'settingscontainers',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingscontainers',
					text: 'Container',
				},
			],
		},
		children: [
			{
				path: '/settingscontainers/',
				beforeEnter: ifAuthenticatedOnline,
				component: AgribiosSettings,
			},
		],
	},
]